export default class InputNumberDirective {
    /**
   * display default image when the first time DOM is loaded
   * @param el 
   */
    inserted(el) {
    }

    /**
     * need reload image when update view model
     * @param el 
     * @param binding 
     * @param vnode 
     * @param oldVnode 
     */
    update(el, binding, vnode, oldVnode) {
        if (/[\d\.]+/i.test(el.value)) {
            console.log('ok');
        } else {
            let newValue = el.value.replace(/[a-zA-Z]+/ig, '');
            el.value = newValue;
            console.log('should fix', newValue);
            binding.value = el.value;
        }
    }

    /**
     * bind when created 
     * @param el 
     * @param binding 
     * @param vnode 
     */
    bind(el, binding, vnode) {
    }

    unbind(el) {
    }
};